<ul>
  <li *ngFor="let layer of Layers">
    <a [class.active]="layer.id === currentLayerId" (click)="initMap(layer.id)"> {{ layer.name }} </a>
  </li>
</ul>
